<template>
    <div ref="pwnedTool" v-if="viewData.isInitializationDone">
        <div class="row" v-if="viewData.currentPage === viewData.pages.SELECT_MODE">
            <div class="column" align="center">
                <h5>
                    Was möchten Sie prüfen?
                </h5>
            </div>
            <div class="small-6 column">
                <button class="button success expand" @click.stop="setMode(modes.EMAIL)">E-Mail Adresse</button>
            </div>
            <div class="small-6 column">
                <button class="button success expand" @click.stop="setMode(modes.PHONE)">Telefonnummer</button>
            </div>
        </div>
        <div class="row" v-else-if="viewData.currentPage === viewData.pages.PWNED_FORM">
            <div class="column">
                <PwnedForm
                    ref="pwnedForm"
                    :show-extended-input="viewData.hasBeenPwned"
                    :mode="viewData.mode"
                    @changeCaseData="onChangeCaseData"
                    @changeMandatorData="onChangeMandatorData"
                    @updateValidity="onUpdateValidity"
                    @submitForm="onFormSubmit"
                />
                <PrivacyHint />
            </div>
            <div class="column small-6" v-if="showChangeModeButton">
                <button :disabled="viewData.isLoading" class="button success expand" @click.stop="changeMode">{{ changeModeButtonLabel }}</button>
            </div>
            <div class="column" v-if="showValidateButton" :class="{ 'small-6': showChangeModeButton }">
                <button class="button warning expand" @click.stop="validateForm">Eingabe prüfen</button>
            </div>
            <div class="column" v-else :class="{ 'small-6': showChangeModeButton }">
                <button :disabled="viewData.isLoading" class="button success expand" @click.stop="sendApiRequest">{{sendButtonLabel}}</button>
            </div>
        </div>
        <div class="row" v-else-if="viewData.currentPage === viewData.pages.NOT_PWNED">
            <div class="column">
                <div class="panel" align="center">
                    <h4 class="ratisColoredText">
                        Gute Nachrichten
                    </h4>
                    <p>
                        Die angegebene {{ pwnedAccountTypeString }} ist nicht vom Datenleck betroffen.
                    </p>
                    <p>
                        Haben Sie Ihre {{ notPwnedAdditionalText }} bereits geprüft? Falls nicht, starten Sie die Eingabe neu und wählen Sie "{{ notPwnedAdditionalText }}" aus.
                    </p>
                </div>
            </div>
            <div class="column">
                <button class="button success expand" @click="resetForm">Neue Eingabe starten</button>
            </div>
        </div>
        <div class="row" v-else-if="viewData.currentPage === viewData.pages.CASE_EXISTS">
            <div class="column">
                <div class="panel" align="center">
                    <h4 class="ratisColoredText">
                        Ihr Schreiben wurde bereits an Meta versendet
                    </h4>
                    <p>
                        Für die angegebene {{ pwnedAccountTypeString }} wurde bereits ein Schreiben an Meta versendet.
                    </p>
                    <p class="bold-text">
                        Haben Sie bereits die Sucheinstellungen in Ihrem Facebookkonto aktualisiert?
                        Falls nicht, klicken Sie dazu <a href="https://www.facebook.com/help/131297846947406" target="_blank">hier</a>
                        und befolgen Sie die aufgeführten Schritte.
                    </p>
                    <p class="bold-text">
                        Dadurch stellen Sie sicher, dass Ihr Konto nicht noch einmal von Unbekannten gefunden und Ihre
                        persönlichen Daten eventuell veröffentlicht werden.
                    </p>
                </div>
            </div>
            <div class="column">
                <button class="button success expand" @click="resetForm">Neue Eingabe starten</button>
            </div>
        </div>
        <div class="row" v-else-if="viewData.currentPage === viewData.pages.SUCCESS_PAGE">
            <div class="column">
                <div class="panel" align="center">
                    <h4 class="ratisColoredText">
                        Ihr Schreiben wurde an Meta versendet
                    </h4>
                    <p>
                        Sie erhalten eine Kopie der versandten E-Mail an die von Ihnen angegebene E-Mail-Adresse.
                    </p>
                    <p>
                        Nun hat Meta zwei Wochen Zeit die geforderte Entschädigung zu leisten. Sie erhalten daher in zwei
                        Wochen eine Erinnerungs-E-Mail von uns. Wenn Meta bis dahin nicht reagiert hat, erhalten Sie
                        darin die Informationen zu den weiteren Schritten.
                    </p>
                    <p class="bold-text">
                        Wir empfehlen Ihnen außerdem in Ihrem Facebookkonto ihre Sucheinstellungen zu aktualisieren.
                        Klicken Sie dazu <a href="https://www.facebook.com/help/131297846947406" target="_blank">hier</a>
                        und befolgen Sie die aufgeführten Schritte.
                    </p>
                    <p class="bold-text">
                        Dadurch stellen Sie sicher, dass Ihr Konto nicht noch einmal von Unbekannten gefunden und Ihre
                        persönlichen Daten eventuell veröffentlicht werden.
                    </p>
                </div>
            </div>
            <div class="column">
                <button class="button success expand" @click="resetForm">Neue Eingabe starten</button>
            </div>
        </div>
        <div class="row" v-else-if="viewData.currentPage === viewData.pages.ERROR_PAGE">
            <div class="column">
                <div class="panel" align="center">
                    <h4 class="redColoredText">
                        Es ist ein Fehler aufgetreten
                    </h4>
                    <p>
                        Wir bitten Sie um Entschuldigung.
                        {{ errorDescription }}
                        Sollten Sie auch nach einem neuerlichen Versuch immer noch Probleme haben, wenden Sie sich bitte an
                        <a href="mailto:info@ratis.de">info@ratis.de</a>.
                    </p>
                </div>
            </div>
            <div class="column">
                <button class="button success expand" @click="resetForm">Erneut versuchen</button>
            </div>
        </div>
        <div class="row" v-else-if="viewData.currentPage === viewData.pages.APP_DOWN">
            <div class="column">
                <div class="panel" align="center">
                    <h4 class="redColoredText">
                        Anwendung nicht verfügbar
                    </h4>
                    <p>
                        Die Anwendung steht aktuell leider nicht zur Verfügung. Bitte versuchen Sie es später erneut.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PwnedForm from '../components/PwnedForm';
import Pwned from '../api/pwned';
import Config from '../constants/Config';
import PrivacyHint from '../components/PrivacyHint';
import Modes from '../constants/Modes';
import Maintenance from '../api/maintenance';

export default {
    name: 'FormView',
    components: {PwnedForm, PrivacyHint},
    data: () => ({
        viewData: {
            currentPage: 0,
            pages: {
                SELECT_MODE:    0,
                PWNED_FORM:     1,
                SUCCESS_PAGE:   2,
                ERROR_PAGE:     3,
                NOT_PWNED:      4,
                CASE_EXISTS:    5,
                APP_DOWN:       6
            },
            hasBeenPwned: false,
            isFormValid: false,
            isLoading: false,
            isCheckError: false,
            isTooManyRequestsError: false,
            mode: null,
            isInitializationDone: false
        },
        caseData: {
            pwned_account: null,
            fb_profile_link: null
        },
        mandator: {
            lawform:        null,
            prename:        null,
            surname:        null,
            street:         null,
            house_number:   null,
            zip:            null,
            city:           null,
            iban:           null,
            bic:            null,
            mail:           null
        },
        constants: {
            TOO_MANY_REQUESTS_STATUS_CODE: 429
        },
        modes: Modes
    }),
    computed: {
        showValidateButton()
        {
            return this.viewData.isFormValid === false;
        },
        sendButtonLabel()
        {
            if (this.viewData.hasBeenPwned)
                return 'Abschicken';
            else
                return 'Jetzt prüfen';
        },
        errorDescription()
        {
            if (this.viewData.isCheckError)
                return 'Leider ist beim Prüfen der ' + this.pwnedAccountTypeString + ' ein Fehler aufgetreten. Bitte versuchen Sie es erneut.';
            else if (this.viewData.isTooManyRequestsError)
                return 'Leider ist beim Prüfen der ' + this.pwnedAccountTypeString + ' ein Fehler aufgetreten, da die maximale Anzahl an Anfragen erreicht wurde. Bitte versuchen Sie es in einer Minute erneut.';

            return 'Leider ist beim Versand des Formulars ein Fehler aufgetreten. Bitte versuchen Sie es erneut.';
        },
        isPhoneNumber()
        {
            return this.viewData.mode === Modes.PHONE;
        },
        pwnedAccountTypeString()
        {
            if (this.isPhoneNumber)
                return 'Telefonnummer';

            return 'E-Mail Adresse';
        },
        changeModeButtonLabel()
        {
            if (this.isPhoneNumber)
                return 'Zu E-Mail Adresse wechseln';
            else
                return 'Zu Telefonnummer wechseln';
        },
        showChangeModeButton()
        {
            return this.viewData.hasBeenPwned === false;
        },
        notPwnedAdditionalText()
        {
            if (this.isPhoneNumber)
                return 'E-Mail Adresse';
            else
                return 'Telefonnummer';
        }
    },
    methods: {
        validateForm()
        {
            this.$refs.pwnedForm.validateForm();
        },
        async sendApiRequest()
        {
            this.viewData.isLoading = true;

            if (this.viewData.hasBeenPwned)
                await this.createCase();
            else
                await this.checkAccount();

            this.viewData.isLoading = false;
        },
        async createCase()
        {
            try
            {
                let requestData = {
                    caseData: this.caseData,
                    mandator: this.mandator
                };

                await Pwned.createNewCase(requestData);
                this.viewData.currentPage = this.viewData.pages.SUCCESS_PAGE;

                this.createTrackingIframe();
            }
            catch (error)
            {
                this.viewData.isCheckError = false;
                this.viewData.isTooManyRequestsError = false;
                this.viewData.currentPage = this.viewData.pages.ERROR_PAGE;
            }
            finally
            {
                this.$refs.pwnedTool.scrollIntoView(true);
            }
        },
        async checkAccount()
        {
            try
            {
                let requestData = {
                    pwned_account: this.caseData.pwned_account
                };

                let response = await Pwned.checkAccount(requestData);
                if (response.caseExists)
                    this.viewData.currentPage = this.viewData.pages.CASE_EXISTS;
                else
                {
                    if (response.pwned === true)
                        this.viewData.hasBeenPwned = true;
                    else
                        this.viewData.currentPage = this.viewData.pages.NOT_PWNED;
                }
            }
            catch (error)
            {
                if (error.response.status === this.constants.TOO_MANY_REQUESTS_STATUS_CODE)
                    this.viewData.isTooManyRequestsError = true;
                else
                    this.viewData.isCheckError = true;

                this.viewData.currentPage = this.viewData.pages.ERROR_PAGE;
            }
            finally
            {
                this.$refs.pwnedTool.scrollIntoView(true);
            }
        },
        onChangeCaseData(newFormData)
        {
            let me = this;
            Object.keys(newFormData).forEach(property => {
                me.caseData[property] = newFormData[property];
            });
        },
        onChangeMandatorData(newFormData)
        {
            let me = this;
            Object.keys(newFormData).forEach(property => {
                me.mandator[property] = newFormData[property];
            });
        },
        onUpdateValidity(newValidity)
        {
            this.viewData.isFormValid = newValidity;
        },
        onFormSubmit()
        {
            if (this.viewData.isFormValid)
                this.sendApiRequest();
            else
                this.validateForm();
        },
        async resetForm()
        {
            await this.checkHealth();

            if (this.viewData.currentPage !== this.viewData.pages.APP_DOWN)
            {
                this.viewData.currentPage = this.viewData.pages.SELECT_MODE;
                this.caseData = {
                    pwned_account: null,
                    fb_profile_link: null
                };
                this.mandator = {
                    lawform:        null,
                    prename:        null,
                    surname:        null,
                    street:         null,
                    house_number:   null,
                    zip:            null,
                    city:           null,
                    iban:           null,
                    bic:            null,
                    mail:           null
                }
                this.viewData.isFormValid = false;
                this.viewData.hasBeenPwned = false;
                this.viewData.isCheckError = false;
                this.viewData.isTooManyRequestsError = false;
                this.viewData.mode = null;
            }
            this.$refs.pwnedTool.scrollIntoView(true);
        },
        setMode(mode)
        {
            this.viewData.mode = mode;

            if (this.viewData.currentPage === this.viewData.pages.SELECT_MODE)
                this.viewData.currentPage = this.viewData.pages.PWNED_FORM;
        },
        changeMode()
        {
            if (this.viewData.mode === Modes.PHONE)

                this.setMode(Modes.EMAIL);
            else
                this.setMode(Modes.PHONE);
        },
        createTrackingIframe()
        {
            let iframe = document.createElement('iframe');
            iframe.setAttribute('id', 'trackingIframe');
            iframe.setAttribute('src', Config.TRACKING_URL);
            iframe.style.display = "none";
            document.body.appendChild(iframe);
            let me = this;
            iframe.onload = () => me.removeTrackingIframe();
        },
        removeTrackingIframe()
        {
            let iframe = document.getElementById('trackingIframe');
            document.body.removeChild(iframe);
        },
        async checkHealth()
        {
            try
            {
                let response = await Maintenance.checkHealth();

                if (response.is_down)
                    this.viewData.currentPage = this.viewData.pages.APP_DOWN;
            }
            catch (error)
            {
                this.viewData.currentPage = this.viewData.pages.APP_DOWN;
            }
        }
    },
    async mounted()
    {
        await this.checkHealth();
        this.viewData.isInitializationDone = true;
    }
};
</script>

<style scoped>
    .ratisColoredText{
        color:#e10065;
    }
    .redColoredText{
        color: red;
    }
    .bold-text {
        font-weight: bold;
    }
</style>